<template>
	<div :class="['meter-score-animation', {'visible': animatingScoreChange}]">
		<FloatingChangeIndicator
			class="floating-change-indicator"
			:animating="animatingScoreChange"
			:meterChange="scoreChangeStatus"
			@complete="removeScoreChange"
		>
			<ChangeIndicator class="change-indicator" :meterChange="scoreChangeStatus" />
		</FloatingChangeIndicator>
	</div>
</template>

<script>
import ChangeIndicator from "@/components/game/review/ChangeIndicator";
import FloatingChangeIndicator from "@/components/base/FloatingChangeIndicator";

export default {
	name: 'MeterChangeAnimation',
	components: {
		ChangeIndicator,
		FloatingChangeIndicator,
	},
	props: {
		scoreId: {
			type: Number,
			required: true,
		},
	},
	computed: {
		score() {
			return this.$store.state.game.scores[this.scoreId].value;
		},
		scoreChangeStatus() {
			return this.$store.getters[`game/scores/${this.scoreId}/change`];
		},
	},
	data() {
		return {
			animatingScoreChange: false,
		};
	},
	methods: {
		showScoreChange() {
			this.animatingScoreChange = true;
		},
		removeScoreChange() {
			this.animatingScoreChange = false;
		},
	},
	mounted() {
		this.$watch('score', () => {
			if (this.$store.getters["game/curveballs/active"]) {
				this.showScoreChange();
			}
		}, { immediate: true });
	},
};
</script>

<style lang="scss" scoped>
	.meter-score-animation {
		position: absolute;
		right: -100%;
		top: 0;
		bottom: 0;
		margin: auto;
		height: 50px;
		width: 50px;
		display: none;

		&.visible { display: block; }
	}

	.change-indicator {
		margin: auto;
		height: 100%;
		width: 100%;
		background: $off-white-dark;
		box-shadow: $box-shadow;
	}
</style>



// WEBPACK FOOTER //
// src/components/base/MeterChangeAnimation.vue